<template>
  <div id="v-html-text" ref="htmlRoot" :style="{ fontFamily: reportFontFamily }">
    <div
      v-image-modal="enableImageModal"
      class="bc-simple-content bc-simple-content-sb"
      v-html="sanitizedContent"
    ></div>
  </div>
</template>

<script>
import { sanitizeHtml } from '@/components/sanitize.js';
import { createTablePaddingMixin } from '@/mixins/tablePaddingMixin';
import { createDiagramScaleMixin } from '@/mixins/diagramScaleMixin';

export default {
  name: 'HtmlText',
  mixins: [
    createTablePaddingMixin({ refName: 'htmlRoot', contentWatchProp: 'sanitizedContent' }),
    createDiagramScaleMixin({ refName: 'htmlRoot', contentWatchProp: 'sanitizedContent' })
  ],
  props: {
    content: { type: String, default: '' },
    enableImageModal: { type: Boolean, default: true }
  },
  computed: {
    reportFontFamily() {
      return this.$store?.getters['report_list/selected_report']?.font_family || null;
    },
    sanitizedContent() {
      return sanitizeHtml(this.content);
    }
  }
};
</script>

<style>
/* 여긴 scoped를 먹이면 적용이 안됨. */
#v-html-text {
  overflow-x: auto;
  line-height: 1.6;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: -0.01px;
  color: #111111;
}

#v-html-text p {
  line-height: 1.6;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: -0.01px;
  color: #111111;
  text-align: justify;
  margin-bottom: 1rem;
  min-height: 1.6rem;
}

#v-html-text p:empty::before {
  content: '\00a0';
  display: inline-block;
}

#v-html-text strong {
  font-weight: 600;
}

#v-html-text img {
  max-width: 100%;
  height: auto;
}

#v-html-text a {
  color: var(--teal) !important;
  background-color: transparent !important;
}

#v-html-text h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
#v-html-text h2 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
#v-html-text h3 {
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
#v-html-text h4 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
#v-html-text h5 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #343434;
  margin-bottom: 0.5rem;
}
#v-html-text h6 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

#v-html-text hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 1rem;
  margin-top: 1rem;
  margin-bottom: 0;
}

#v-html-text blockquote {
  border-left: 3px solid #dee2e6;
  padding: 0.25rem 0 0.25rem 1rem;
  color: #6c757d;
  font-style: italic;
  margin: 0.5rem 0;
}

#v-html-text ul,
#v-html-text ol {
  padding-inline-start: 1rem !important;
  font-weight: 400;
}

#v-html-text ol {
  list-style-type: decimal;
}
#v-html-text ol ol {
  list-style-type: lower-alpha;
}
#v-html-text ol ol ol {
  list-style-type: lower-roman;
}
#v-html-text ol ol ol ol {
  list-style-type: decimal;
}
#v-html-text ol ol ol ol ol {
  list-style-type: lower-alpha;
}
#v-html-text ol ol ol ol ol ol {
  list-style-type: lower-roman;
}

#v-html-text ul {
  list-style-type: disc;
}
#v-html-text ul ul {
  list-style-type: circle;
}
#v-html-text ul ul ul {
  list-style-type: square;
}
#v-html-text ul ul ul ul {
  list-style-type: disc;
}
#v-html-text ul ul ul ul ul {
  list-style-type: circle;
}
#v-html-text ul ul ul ul ul ul {
  list-style-type: square;
}

#v-html-text table {
  width: 100% !important;
  max-width: 100%;
  table-layout: fixed;
  border-left: none !important;
  border-right: none !important;
}

#v-html-text table > tbody > tr {
  height: 32px;
}

#v-html-text table > tbody > tr > td {
  padding: var(--table-v-padding, 0.25rem) var(--table-h-padding, 0.75rem);
  border-bottom: 1px solid #dedede;
  font-weight: 400;
  font-size: 0.9rem;
  background-color: white;
  vertical-align: middle;
}

#v-html-text table > tbody > tr > td > p {
  margin-bottom: 0 !important;
  font-weight: 400 !important;
  font-size: 0.9rem;
  min-height: auto;
}

#v-html-text table > tbody > tr > th,
#v-html-text table > thead > tr > th {
  padding: var(--table-v-padding, 0.25rem) var(--table-h-padding, 0.75rem);
  border-top: 1px solid #a2a2a2;
  border-bottom: 1px solid #a2a2a2;
  font-weight: 600;
  background-color: #efefef;
  color: #202020;
  font-size: 0.9rem;
  vertical-align: middle;
}

@media screen and (max-width: 768px) {
  #v-html-text table {
    width: 100%;
    max-width: 100%;
    table-layout: auto;
  }
}
</style>
